"use strict";

const WRAPPER_SELECTOR = ".live-search";
const INPUT_SELECTOR = ".live-search-input";
const ACTION_SELECTOR = "[data-live-search-action]";

function updateLiveSearchAction(input, action) {
    const hasValue = input.value.length > 0;

    action.classList.toggle("is-filled", hasValue);
    action.tabIndex = hasValue ? 0 : -1;
    action.setAttribute(
        "aria-label",
        hasValue ? action.dataset.clearLabel : action.dataset.searchLabel
    );
}

function initLiveSearchActions() {
    document.querySelectorAll(WRAPPER_SELECTOR).forEach((wrapper) => {
        const input = wrapper.querySelector(INPUT_SELECTOR);
        const action = wrapper.querySelector(ACTION_SELECTOR);

        if (!input || !action) {
            return;
        }

        action.dataset.searchLabel = action.getAttribute("aria-label") || "";

        const syncAction = () => updateLiveSearchAction(input, action);

        input.addEventListener("input", syncAction);

        action.addEventListener("click", () => {
            if (!input.value) {
                return;
            }

            input.value = "";
            input.dispatchEvent(new Event("input", { bubbles: true }));
            input.dispatchEvent(new Event("search", { bubbles: true }));
            syncAction();
            input.focus();
        });

        syncAction();
    });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLiveSearchActions, { once: true });
} else {
    initLiveSearchActions();
}
